<div class="slider">
  <div class="slides">
    <div *ngFor="let img of images; let i = index" class="slide" [class.active]="i === currentIndex">
      <picture>
        <source [srcset]="img.mob" media="(max-width: 768px)" />
        <img [src]="img.desktop" alt="slide" />
      </picture>
    </div>
  </div>
  <!--
  <button class="prev" (click)="prevSlide()">‹</button>
  <button class="next" (click)="nextSlide()">›</button>
-->
</div>